<template>
  <div>
    <!-- <h4 class="font-weight-bold py-3 mb-4">Account</h4> -->

    <b-card
      no-body
      class="overflow-hidden"
    >
   
      <div class="row no-gutters row-bordered row-border-light">
        <div class="col-md-3 pt-0">
          <b-list-group
            class="account-settings-links"
            flush
          >
            <b-list-group-item
              button
              :active="curTab === 'profile'"
              @click="curTab = 'profile'"
            >Brukerprofil</b-list-group-item>
            <!-- <b-list-group-item
              button
              :active="curTab === 'security'"
              @click="curTab = 'security'"
              >Password</b-list-group-item
            >
            <b-list-group-item
              button
              :active="curTab === 'subscription'"
              @click="curTab = 'subscription'"
              >Subscription</b-list-group-item
            > -->
          </b-list-group>
        </div>

        <div
          class="col-md-9"
          v-if="curTab === 'profile'"
        >
          <b-card-body>
            <h5>Brukerprofil</h5>
            <hr />

            <b-form-group label="Navn">
              <b-input v-model="user.username" />
            </b-form-group>

            <b-form-group label="E-post">
              <b-input
                disabled
                v-model="user.email"
              />
            </b-form-group>

            <b-form-group label="Språk">
              <b-form-select
                v-model="user.language"
                :options="languages"
              ></b-form-select>
            </b-form-group>

            <b-form-group>
              <b-alert
                variant="warning"
                show
                class="mt-3 mb-0"
                v-if="!user.confirmed"
              >
                Your email is not confirmed. Please check your inbox.<br />
                <a href="javascript:void(0)">Resend confirmation</a>
              </b-alert>
            </b-form-group>

            <!-- <vue-json-pretty :data="user"> </vue-json-pretty> -->
          </b-card-body>
        </div>

        <div
          class="col-md-9"
          v-if="curTab === 'security'"
        >
          <b-card-body class="pb-2">
            <h5>Change password</h5>
            <hr />

            <b-form-group label="Current password">
              <b-input
                v-model="oldPassword"
                type="password"
                placeholder="Old password"
              />
            </b-form-group>

            <ValidationProvider
              rules="required"
              name="Password"
              vid="password"
            >
              <b-form-group
                slot-scope="{ valid, errors }"
                label="Password"
              >
                <b-form-input
                  type="password"
                  v-model="newPassword"
                  :state="errors[0] ? false : valid ? true : null"
                  placeholder="Enter password"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <ValidationProvider
              rules="required|confirmed:password"
              name="Confirm Password"
            >
              <b-form-group
                slot-scope="{ valid, errors }"
                label="Confirm Password"
              >
                <b-form-input
                  type="password"
                  v-model="confirmationPassword"
                  placeholder="Confirm password"
                  :state="errors[0] ? false : valid ? true : null"
                >
                </b-form-input>
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-button
              @click="changePassword()"
              variant="primary"
            >Change Password</b-button>

            <b-alert
              class="mt-3"
              v-if="this.status == 'Success'"
              variant="success"
              show
            >Password changed successfully</b-alert>

            <b-alert
              class="mt-3"
              v-if="this.status == 'Failed'"
              variant="danger"
              show
            >Could not change password</b-alert>

            <br />
            <br />
          </b-card-body>
        </div>

        <!-- <div class="col-md-9" v-if="curTab === 'subscription'">
          <b-card-body class="pb-2">
            <h5>Subscription</h5>
            <hr />

            <b-form-group label="Active subscription">
              {{ user.subscription }}
            </b-form-group>

            <b-button variant="primary" v-b-modal.subscription
              >Change subscription</b-button
            >

            <b-modal id="subscription" title="Change subscription">
              <b-form-group label="Choose subscription">
                <b-form-select
                  id="category"
                  v-model="changeSubscription"
                  :options="subscriptions"
                ></b-form-select>
              </b-form-group>

              <template v-slot:modal-footer>
                <div class="w-100">
                  <p class="float-left">
                    <a
                      class="footer-text footer-link small mb-3"
                      href="mailto:help@packtracker.com"
                      >Need help?</a
                    >
                  </p>
                  <b-button
                    class="mr-2 float-right"
                    variant="default"
                    @click="closeModal()"
                    >Cancel</b-button
                  >
                </div>
              </template>

              <stripe-checkout
                pk="pk_live_YAJPPaG1HL7d9zlDyvYzLz9500ZrG5LtIV"
                ref="subscribeRef"
                :items="selectedPlan"
                :success-url="successUrl"
                :cancel-url="cancelUrl"
                :client-reference-id="this.user.stripe"
                :customerEmail="this.user.email"
              >
                <template slot="checkout-button">
                  <b-btn
                    class="mb-3 ml-1"
                    variant="primary"
                    @click="updateSubscription()"
                    >Proceed to payment</b-btn
                  >
                </template>
              </stripe-checkout>
            </b-modal>

            <br />

            <br />
          </b-card-body>
        </div> -->
      </div>
    </b-card>

    <div class="text-right mt-3">
      <b-btn
        variant="default"
        class="mr-2"
        @click="goDashboard()"
      >Avbryt</b-btn>
      <b-btn
        variant="primary"
        @click="updateUser()"
      >Lagre endringer</b-btn>&nbsp;
    </div>
  </div>
</template>


<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<!-- Page -->

<style src="@/vendor/styles/pages/account.scss" lang="scss"></style>

<script>
import axios from "axios";

export default {
  name: "pages-account-settings",
  metaInfo: {
    title: "Account",
  },
  components: {
  },
  data() {
    return {
      user: {
        confirmed: true,
      },
      curTab: "profile",
      isLoading: false,
      fullPage: true,
      oldPassword: "",
      newPassword: "",
      password: "",
      confirmation: "",
      subscriptions: [
        { value: "Free", text: "Free - 0$/mo" },
        { value: "Starter", text: "Starter - 69$/mo" },
        { value: "Standard", text: "Standard - 199$/mo" },
        { value: "Professional", text: "Professional - 299$/mo" },
      ],
      changeSubscription: "",
      customerStripeRef: "",
      selectedPlan: [],
      publishableKey: "pk_live_YAJPPaG1HL7d9zlDyvYzLz9500ZrG5LtIV",
      successUrl:
        "https://www.packtracker.com/#/payment/success?session_id={CHECKOUT_SESSION_ID}",
      cancelUrl: "https://www.packtracker.com/#/payment/cancel",
      sessionId: "",
      languages: [
        { value: "en", text: "English" },
        { value: "no", text: "Norsk" },
      ],
    };
  },

  methods: {
    getUser() {
      axios
        .get("https://api.eines-as.no/users/me")
        .then((res) => {
          this.user = res.data;
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    updateUser() {
      this.isLoading = true;

      axios
        .put("https://api.eines-as.no/users/" + this.user.id, this.user)
        .then((response) => {
          this.$i18n.locale = this.user.language;

          this.$router.push("/customer/home");
          this.isLoading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.isLoading = false;
        });
    },
    changePassword() {
      var passwordData = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
      };

      axios
        .post(
          "https://www.packtracker.com/api/users/change-password",
          passwordData
        )
        .then((response) => {
          this.status = "Success";
          this.oldPassword = "";
          this.newPassword = "";
        })
        .catch(function (error) {
          console.log(error);
          this.status = "Failed";
        });
    },

    closeModal() {
      this.$router.push("/customer/home");
    },
    goDashboard() {
      this.$router.push("/customer/home");
    },
  },
  watch: {
    user: function () {
      this.$i18n.locale = this.user.language;
    },
  },
  mounted: function () {
    return this.$store.getters.userEmail;
  },
  created: function () {
    this.getUser();
  },
};
</script>


<style lang="css">
.list-group-item.active,
.list-group-item.active:hover,
.list-group-item.active:focus {
  border-color: #e2e2e2;
  background-color: #ffffff;
  color: #801529;
}
</style>